import * as angular from "angular";
import {IHttpInterceptor, IHttpProvider, ILocationService, ILogService, IPromise, IQService, IWindowService} from "angular";
import uiRouter, {StateProvider, StateRegistry, StateService, TransitionService} from "@uirouter/angularjs";
import {AuthService} from "./auth.service";
import {LoginComponent} from "./login/login.component";
import {LayoutComponent} from "../widget/layout/layout.component";
import {LoginFormComponent2} from "./login/login-form.component";


class HttpAuthInterceptor implements IHttpInterceptor {

    /* @ngInject */
    public static factory($location: ILocationService, $log: ILogService, $q: IQService, $window: IWindowService): HttpAuthInterceptor {
        return new HttpAuthInterceptor($location, $log, $q, $window);
    }

    constructor(private $location: ILocationService,
                private $log: ILogService,
                private $q: IQService,
                private $window: IWindowService) {
    }

    public responseError = (responseFailure): IPromise<any> => {
        switch (responseFailure.status) {
            case 401:
                this.$log.error("Not authorised. Redirecting to login page...", responseFailure);
                this.$window.location.href = `/login?next=${encodeURIComponent(this.$location.url())}`;
                break;
            case 403:
                this.$log.error("Insufficient permissions.", responseFailure);
                this.$window.location.href = "/forbidden";
                break;
        }
        return this.$q.reject(responseFailure);
    }
}


const requiresLogin = (state) => !/^\/(login|logout|forbidden|not-found|invalid-status)(?![^\/?])(.*)/i.test(state.url);

const hasAuthorisation = (state, user) => {
    switch (state.parent.name) {
        case "student":
            return user.isStudent;
        case "staff":
            return user.isStaff || user.isAssessor;
        case "admin":
            return user.isStaff;
        default:
            return false;
    }
};

export const AuthModule = angular
    .module("app.shared.auth", [uiRouter])

    .service("authService", AuthService)
    .component("loginForm2", LoginFormComponent2)
    .component("loginPage", LoginComponent)

    .config(($stateProvider: StateProvider) => {
        $stateProvider
            .state("home", {
                url: "/"  // facilitates redirection to role appropriate home page
            })

            .state("login", {
                url: "/login?next",
                component: "loginPage"
            })

            .state("localLogin", {
                url: "/login/local?SAMLRequest&RelayState",
                template: require("./local-login.html")
            })

            .state("logout", {
                url: "/logout",
                controller: ($state, authService: AuthService) => {
                    authService.logout().then(() => $state.go("login"));
                }
            })

            .state("forbidden", {
                url: "/forbidden",
                template: require("./403.html")
            });
    })

    .config(($httpProvider: IHttpProvider) => {
        $httpProvider.interceptors.push(HttpAuthInterceptor.factory);
    })

    .run(($transitions: TransitionService,
          $log: ILogService,
          $window: IWindowService,
          $location: ILocationService,
          $state: StateService,
          $stateRegistry: StateRegistry,
          authService: AuthService) => {
        $transitions.onStart({to: (state) => requiresLogin(state)}, (transition) =>
            authService.isAuthenticated()
                .then((authenticated) => {
                    if (!authenticated) {
                        return;  // cancel transition
                    }

                    return authService.me()
                        .then((user) => {
                            if (transition.$to().name === "home") {
                                transition.abort();
                                const nextPage = (user.isStaff && user.isStudent) ? "student.switchMode" :
                                    (user.isStaff || user.isAssessor) ? "staff.dashboard" : "student.dashboard";
                                $state.go(nextPage);
                            } else if (!hasAuthorisation(transition.$to(), user)) {
                                $log.error("User is not authorised to view %s: %o", transition.$to().name, user);
                                transition.abort();
                                $state.go("forbidden");
                            }
                        });
                })
        );
    })

    .name;




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/auth/auth.module.ts